import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../actions/apps";
import * as actionLibraries from "../../actions/library";
import Title from "../../components/common/Title";
import colors from "../../styles/colors";
import layout from "../../styles/layout";
import LibraryInstructionPrint from "../playbook/LibraryInstructionPrint";
import LibraryInstructionCard from "../libraries/libraryPage/LibraryInstructionCard";
import AppFrame from "./../Appframe/AppFrame";
import "./librariesPage.css";
import ActionDialogue from "../../components/common/ActionDialogue";
import { deleteLibrary } from "../../services/middleware";
import { Button, FormControl, InputLabel } from "@material-ui/core";
import PhysiotecService from "../../services/physiotec";
import StarIcon from "@material-ui/icons/Star";
import sort from "fast-sort";
import Select from "@material-ui/core/Select";
import Loader from "react-loader-advanced";

const styles = {
  playbookContainer: {
    width: "75%",
    borderRadius: 16,
    borderWidth: 1,
    borderColor: colors.text,
    padding: 4,
  },
  userChannelHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  topMenuButtonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    marginTop: 25,
    marginBottom: 15,
  },
  button: {
    width: 160,
    border: "2px solid grey",
    borderRadius: 8,
    padding: 4,
    marginRight: 4,
    marginLeft: 4,
  },
  buttonImage: {
    width: 24,
    height: 24,
    padding: 5,
    margin: 0,
    border: "2px solid #52829D",
    borderRadius: 18,
  },

  cardsContainer: {
    display: "flex",
    flexDirection: "row",
    /* justify-content: center; */
    flexWrap: "wrap",
    padding: 40,
  },
};

class librariesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: props.match.params.appId,
      userId: this.props.userId,
      appTemplate: null,
      libraries: [],
      categories: [],
      selectedCategories: [],

      searchText: "",
      canSearchByGroup: false,
      printableLib: null,
      deletableLib: null,
      width: 0,
      height: 0,
      showIFrame: false,
      isOpeningPhysioSSO: false,
      onlyFavorites: false,
      selectedFilter: "all",
      selectedProgram: null,
      dropDownOptions: [
        { value: "all", label: "Show All Instructions" },
        { value: "fav", label: "Show My Favorites" },
      ],
    };

    this.openSSO = this.openSSO.bind(this);
    this.showSync = this.showSync.bind(this);
    this.isFavorite = this.isFavorite.bind(this);
    this.addFav = this.addFav.bind(this);
    this.deleteFav = this.deleteFav.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));

    PhysiotecService()
      .getIntegrationEnabled(this.state.appId)
      .then((response) => {
        if (response) {
          this.setState({
            physioEnabled: response.isIntegrationEnabled,
            physioEntityNumber: response.entityNumber,
          });
        }
      })
      .catch((err) => {});
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    this.props.getAppTemplate(this.state.userId, this.state.appId, 103);
    this.props.getAppFavorites(this.state.appId, this.state.userId);
  }

  componentWillReceiveProps(nextProps, oldProps) {
    if (nextProps !== oldProps) {
      if (nextProps.apps.providerAppId) {
        let appTemplate =
          nextProps.apps.appTemplates[nextProps.apps.providerAppId];

        if (appTemplate && appTemplate.groups) {
          let categories = appTemplate.groups.map((group) => group.groupName);

          let dropDownOptions = [
            { value: "all", label: "Show All Instructions" },
            { value: "fav", label: "Show My Favorites" },
          ];
          appTemplate.programs
            .filter((p) => {
              return !p.systemUse;
            })
            .map((p) => {
              dropDownOptions.push({
                value: p.programId,
                label: p.programName,
              });
              return true;
            });
          this.setState({
            appTemplate: appTemplate,
            libraries: this.getLibraries(appTemplate.groups),
            categories: categories,
            selectedCategories: categories,
            coverUrl:
              nextProps.apps.appInfos[nextProps.apps.providerAppId].coverUrl,
            programs:
              nextProps.apps.appTemplates[nextProps.apps.providerAppId]
                .programs,
            dropDownOptions,
          });
        }
      }
    }
  }

  getLibraries(libraries) {
    let results = [];
    libraries.map((group, groupIndex) =>
      group.categories.map((category, categoryIndex) => {
        category.isFavorite = this.isFavorite(category.categoryId);
        results.push({
          library: category,
          categoryName: group.groupName,
          groupId: group.groupId,
          groupIndex,
          categoryIndex,
          categoryId: category.categoryId,
        });
        return true;
      })
    );
    return results;
  }

  addNewLibrary() {
    const libraries = this.state.libraries.map(
      (library) => library.categoryName
    );
    this.props.clearLibraryFromLibraries();
    this.props.setCategoriesFromLibraries(
      libraries.filter((name, index) => libraries.indexOf(name) === index)
    );
    this.props.history.push("/new-library/" + this.state.appId);
  }

  editLibrary(library) {
    this.props.setSelectedLibraryFromLibraries(library, "Edit");
    this.props.history.push("/edit-library/" + this.state.appId);
  }

  deleteLibrary(library) {
    this.setState({ deletableLib: library }, () => {
      this.refs.deleteConfirmDialogue.open();
    });
  }

  showLibrary(library) {
    this.props.setSelectedLibraryFromLibraries(library, "Show");
    this.props.history.push("/library/" + this.state.appId);
  }

  deleteConfirmDialogue() {
    return (
      <ActionDialogue
        ref="deleteConfirmDialogue"
        title="Warning"
        content="Are you sure you want to delete the instruction from the library?"
        onConfirm={() => {
          const updatedTemp = deleteLibrary(
            this.state.appTemplate,
            this.state.deletableLib
          );
          if (updatedTemp !== null) {
            this.props.updateAppTemplate(
              this.props.userId,
              this.state.appId,
              updatedTemp
            );
            this.props.clearLibraryFromLibraries();
            this.props.history.push("/libraries/" + this.state.appId);
            this.setState({ deletableLib: null });
          } else {
            alert(
              "Unable to delete this instruction. Please refresh the page and try again."
            );
          }
        }}
      />
    );
  }

  printInstruction(library) {
    let containerEl = document.createElement("div");
    const input = document.getElementById(
      `divLibraryInstructions_${library.library.id}`
    );
    input.style.display = "block";
    let inputClone = input.cloneNode(true);
    input.appendChild(inputClone);
    containerEl.appendChild(inputClone);
    input.style.display = "none";
    const externalWindow = window.open(
      "",
      "",
      "width=1000,height=500,left=200,top=200"
    );
    externalWindow.document.body.appendChild(containerEl);
    //Trigger automatic print and close window after.
    externalWindow.onafterprint = () => {
      externalWindow.close();
    };
    externalWindow.print();
    this.setState({ printableLib: null });
  }

  goToChannelDetails() {
    let link = `/view-app-detail/${this.state.appId}`;
    this.props.history.push(link);
  }

  isFavorite(id) {
    if (
      this.props.apps &&
      this.props.apps.appFavorite &&
      this.props.apps.appFavorite.instructions
    ) {
      return this.props.apps.appFavorite.instructions.includes(id);
    } else {
      return false;
    }
  }

  showSync() {
    this.refs.syncDialog.open();
    PhysiotecService()
      .syncPhysioLiberary(this.state.userId, this.state.appId)
      .then((resp) => {
        if (resp.msg === "ok") {
          this.refs.syncDialog.close();
          this.props.getAppTemplate(this.state.userId, this.state.appId, 103);
          alert("Sync Complete!");
        }
      });
  }

  syncDialog() {
    return (
      <div>
        <ActionDialogue
          ref="syncDialog"
          title="Syncing Data Please Wait..."
          content="This may take a few moments while data is transfered into your AC Health Library."
          onConfirm={() => {
            this.refs.syncDialog.close();
          }}
        />
        <ActionDialogue
          ref="refreshDialog"
          title="Data Sync Warning"
          content="If you have made changes in the Physiotec/Wibbi library remember to sync them to your AC Health account by pressing the 'Sync Physiotec/Wibbi Library Button'."
          onConfirm={() => {
            this.refs.refreshDialog.close();
          }}
        />
      </div>
    );
  }
  addFav(id) {
    this.props.addAppFavorite(this.state.appId, this.props.user.userId, id);

    //Also adjust current state
    const updatedLibs = this.state.libraries.map((libItem) => {
      //set the item to favorite if it was the one added
      if (libItem.library.categoryId === id) {
        libItem.library.isFavorite = true;
      }
      return libItem;
    });
    this.setState({ libraries: updatedLibs });
  }

  deleteFav(id) {
    this.props.deleteAppFavorite(this.state.appId, this.props.user.userId, id);
    //Also adjust current state
    const updatedLibs = this.state.libraries.map((libItem) => {
      //set the item to favorite if it was the one added
      if (libItem.library.categoryId === id) {
        libItem.library.isFavorite = false;
      }
      return libItem;
    });
    this.setState({ libraries: updatedLibs });
  }

  async openSSO() {
    this.setState({ isOpeningPhysioSSO: true });
    try {
      const resp = await PhysiotecService().getSSOLink(
        this.state.userId,
        this.state.appId
      );

      const ssoUrl = resp && resp.url ? resp.url : null;
      if (!ssoUrl) {
        alert("Unable to open Physiotec/Wibbi. Please try again.");
        return;
      }

      const openedWindow = window.open(ssoUrl, "_blank");
      if (!openedWindow) {
        alert(
          "Please allow popups in your browser settings for this site and try again."
        );
      }
    } catch (e) {
      alert("Unable to open Physiotec/Wibbi. Please try again.");
    } finally {
      this.setState({ isOpeningPhysioSSO: false });
    }
  }
  handleSelectionChange(e) {
    let selectedProgram = null;
    if (e.target.value !== "fav" && e.target.value !== "") {
      let arr = this.state.programs.filter((p) => {
        return p.programId === e.target.value;
      });
      selectedProgram = arr[0];
    }
    this.setState({ selectedFilter: e.target.value, selectedProgram });
  }

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }

    let filteredLibraries = this.state.libraries;

    filteredLibraries = filteredLibraries.filter((lib) => {
      if (this.state.selectedFilter === "all") {
        return true;
      } else if (this.state.selectedFilter === "fav") {
        return lib.library.isFavorite;
      } else {
        return this.state.selectedProgram.instructions.includes(
          lib.library.categoryId
        );
      }
    });
    if (this.state.canSearchByGroup) {
      filteredLibraries = filteredLibraries.filter((library) =>
        library.library.groupName
          .toLowerCase()
          .startsWith(this.state.searchText.toLowerCase())
      );
    } else {
      filteredLibraries = filteredLibraries.filter((library) =>
        library.library.categoryName
          .toLowerCase()
          .includes(this.state.searchText.toLowerCase())
      );
    }

    filteredLibraries = sort(filteredLibraries).asc([
      (c) => c.library.groupName,
      (c) => c.library.categoryName,
    ]);

    return (
      <AppFrame
        auth={this.props.auth}
        targetDevice={targetDevice}
        header="Manage Library"
        optionsType="channels"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <Loader
          className="physio-sso-loader"
          show={this.state.isOpeningPhysioSSO}
          message={"Loading...."}
        >
          <div style={layout.common.page}>
            <Title
              goBack={() => this.goToChannelDetails()}
              showIframe={this.state.showIFrame}
              closeIframe={() => {
                this.setState({ showIFrame: false });
                this.refs.refreshDialog.open();
              }}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />

            <div style={layout.common.mainContainer}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                {!this.state.showIFrame && (
                  <Button
                    onClick={() => {
                      this.addNewLibrary();
                    }}
                    variant="outlined"
                    style={{
                      margin: 10,
                      backgroundColor: colors.accent,
                      color: "white",
                    }}
                  >
                    + Add New Library Instruction
                  </Button>
                )}
                {!this.state.showIFrame && this.state.physioEnabled && (
                  <Button
                    disabled={this.state.isOpeningPhysioSSO}
                    onClick={() => {
                      this.openSSO();
                    }}
                    variant="outlined"
                    style={{ margin: 10 }}
                  >
                    View Physiotec/Wibbi Library
                  </Button>
                )}

                {!this.state.showIFrame && this.state.physioEnabled && (
                  <Button
                    onClick={() => {
                      this.showSync();
                    }}
                    style={{ margin: 10 }}
                    variant="outlined"
                  >
                    Sync Physiotec/Wibbi Library
                  </Button>
                )}
              </div>
              {this.state.showIFrame && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    height: "7000px",
                  }}
                >
                  <iframe
                    src={this.state.iFrameUrl}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                      zoom: 0.75,
                    }}
                    title="Physiotec/Wibbi SSO Link"
                  />
                </div>
              )}
            </div>

            {!this.state.showIFrame && (
              <div style={layout.common.mainContainer}>
                <div style={layout.common.filterRow}>
                  <div style={layout.common.searchWithDropDown}>
                    <FormControl variant="outlined">
                      <InputLabel htmlFor="outlined-filter">Filter</InputLabel>
                      <Select
                        native
                        value={this.state.selectedFilter}
                        onChange={this.handleSelectionChange}
                        label="Filter"
                        inputProps={{
                          name: "filter",
                          id: "outlined-filter",
                        }}
                      >
                        {this.state.dropDownOptions.map((o) => {
                          return <option value={o.value}>{o.label}</option>;
                        })}
                      </Select>
                    </FormControl>
                  </div>
                  <div style={layout.common.searchWithDropDown}>
                    <TextField
                      id="filled-full-width"
                      label="Search"
                      style={{ margin: 8 }}
                      placeholder={
                        this.state.canSearchByGroup
                          ? "Search By Category"
                          : "Search By Name"
                      }
                      fullWidth
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      value={this.state.searchText}
                      onChange={(e) => {
                        this.setState({ searchText: e.target.value });
                      }}
                    />
                    <IconButton
                      color="primary"
                      aria-label="Clear Search"
                      component="span"
                      onClick={() => this.setState({ searchText: "" })}
                      style={layout.common.searchFieldCancel}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.showAll}
                        onChange={(val) => {
                          const curVal = this.state.canSearchByGroup;
                          this.setState({ canSearchByGroup: !curVal });
                        }}
                        name="toggleAll"
                        color="primary"
                      />
                    }
                    label="Search By Category"
                  />
                </div>
              </div>
            )}
            {!this.state.showIFrame && (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={styles.cardsContainer}>
                  {filteredLibraries.map((library, index) => (
                    <LibraryInstructionCard
                      key={`${library.groupId || library.groupIndex}-${library.categoryId}`}
                      instruction={library}
                      index={index}
                      printInstruction={(library) => {
                        this.setState({ printableLib: library }, () =>
                          this.printInstruction(library)
                        );
                      }}
                      showLibrary={(library) => {
                        this.showLibrary(library);
                      }}
                      editLibrary={(library) => {
                        this.editLibrary(library);
                      }}
                      deleteLibrary={(library) => {
                        this.deleteLibrary(library);
                      }}
                      addAppFavorite={(id) => {
                        this.addFav(id);
                      }}
                      deleteAppFavorite={(id) => {
                        this.deleteFav(id);
                      }}
                      coverUrl={this.state.coverUrl}
                      whiteLabelSettings={this.props.whiteLabelSettings}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </Loader>

        {this.deleteConfirmDialogue()}
        {this.syncDialog()}

        {this.state.printableLib !== null && (
          <LibraryInstructionPrint
            category={this.state.printableLib.library}
            id={`divLibraryInstructions_${this.state.printableLib.library.id}`}
          />
        )}
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, library, whiteLabelSettings }) {
  return {
    user,
    userId: user.userId,
    apps,
    library,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign({}, actionCreators, actionLibraries),
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(librariesPage);



// WEBPACK FOOTER //
// ./src/layout/libraries/librariesPage.js